
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomePageComponent } from './home-page/home-page.component';
import { ProductsComponent } from './products/products.component';
import { CategoriesResolverService } from './categories-resolver.service';
import { ProductsResolverService } from './products-resolver.service';
import { SearchResolverService } from './search-resolver.service';
import { SearchResultsComponent } from './search-results/search-results.component';
import { CategoriesComponent } from "./categories/categories.component";


const routes: Routes = [
  {
    path: "home-page",
    component: HomePageComponent
  },
  {
    path: "products/:id",
    component: ProductsComponent,
    resolve: {
      categoryProducts: ProductsResolverService
    }
  },
  {
    path: "category/:id",
    component: CategoriesComponent,
    resolve: {
      categoryResults: CategoriesResolverService
    }
  },
  {
    path: "category",
    component: CategoriesComponent,
    resolve: {
      categoryResults: CategoriesResolverService
    }
  },
  {
    path: "search/:s",
    component: SearchResultsComponent,
    resolve: {
      searchResults: SearchResolverService
    }
  },
  {
    path: "**",
    redirectTo: "home-page"
  },
  {
    path: "",
    redirectTo: "home-page",
    pathMatch: "full"
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [
    CategoriesResolverService,
    ProductsResolverService,
    SearchResolverService
  ]
})
export class AppRoutingModule { }




// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts


// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts